export default (percentage) => {
  if (Number.isInteger(percentage)) {
    return `${percentage.toLocaleString('pt-br')}%`;
  } else {
    return `${percentage.toLocaleString('pt-br', { minimumFractionDigits: 1, maximumFractionDigits: 2 })}%`;
  }
};
